// extracted by mini-css-extract-plugin
module.exports = {"select":"locale-dropdown_select__aWkbT"};